import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { CustomTooltipComponent } from '../features/layout/components/custom-tooltip/custom-tooltip.component';

@Directive({
  selector: '[appCustomTooltip]',
  standalone: true,
})
export class CustomTooltipDirective {
  @Input('appCustomTooltip') tooltipContent = '';

  private tooltipRef: ComponentRef<CustomTooltipComponent> | null = null;

  constructor(
    private el: ElementRef,
    private vcr: ViewContainerRef,
    private cfr: ComponentFactoryResolver,
  ) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.tooltipRef) {
      const factory = this.cfr.resolveComponentFactory(CustomTooltipComponent); // ✅ fixed
      this.tooltipRef = this.vcr.createComponent(factory);

      const tooltip = this.tooltipRef.instance;
      tooltip.content = this.tooltipContent;
      tooltip.show = true;

      const hostEl = this.el.nativeElement;
      hostEl.style.position = 'relative';
      const nativeTooltip = (this.tooltipRef.hostView as any).rootNodes[0] as HTMLElement;
      hostEl.appendChild(nativeTooltip);
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltipRef) {
      this.tooltipRef.destroy();
      this.tooltipRef = null;
    }
  }

  ngOnDestroy() {
    if (this.tooltipRef) {
      this.tooltipRef.destroy();
    }
  }
}
